import React, { useState, createContext } from 'react';
import PropTypes from 'prop-types';

// Defaulted so consumers rendered outside the provider (e.g. in isolated
// tests) can destructure the pair without blowing up.
export const NotificationContext = createContext([null, () => {}]);

export const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState(null);
  return (
    <NotificationContext.Provider value={[notification, setNotification]}>
      {children}
    </NotificationContext.Provider>
  );
};

NotificationProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
